import React from 'react';
import { motion } from 'framer-motion';

export default function DataVizBar({ data }) {
  return (
    <div className="space-y-4 my-8">
      {data.map((item, idx) => (
        <div key={idx} className="relative">
          <div className="flex justify-between text-sm font-medium mb-1.5">
            <span className={item.highlight ? 'text-slate-900 font-bold' : 'text-slate-600'}>
              {item.label}
            </span>
            <span className={item.highlight ? 'text-slate-900 font-bold' : 'text-slate-600'}>
              {item.value}%
            </span>
          </div>
          <div className="w-full bg-slate-100 rounded-full h-3 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              whileInView={{ width: `${item.value}%` }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: idx * 0.1, ease: "easeOut" }}
              className={`h-full rounded-full ${
                item.highlight ? 'bg-peridot-500' : 'bg-slate-300'
              }`}
            />
          </div>
        </div>
      ))}
    </div>
  );
}